import React from 'react';

import * as styles from '../styles/PageSlider.styles';

export interface PageSliderProps {
  children: React.ReactNode;
  pageIndex?: number;
  transition?: string;
}

export const PAGE_SLIDER_PAGE_CLASS_NAME = 'pageslider__page';

export const PageSlider = ({ children, transition, ...props }: PageSliderProps) => {
  const pageIndex = props.pageIndex ?? 0;
  const pages = React.Children.count(children);
  const pagesWidth = `${pages * 100}%`;
  const pagesTranslateX = `-${pageIndex * (100 / pages)}%`;
  const pageWidth = `${100 / pages}%`;

  return (
    <div css={styles.pagesWrapper}>
      <div
        css={styles.pages}
        data-testid="pageslider__pages"
        style={
          {
            width: pagesWidth,
            '--translateX': pagesTranslateX,
            transition: transition,
          } as styles.PagesCSSProperties
        }
      >
        {React.Children.map(children, (child, index) => (
          <div
            aria-hidden={index !== pageIndex}
            className={PAGE_SLIDER_PAGE_CLASS_NAME}
            data-testid="pageslider__page"
            style={{ width: pageWidth }}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};
